<div class="modal fade" id="docketUpload" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">

    <div class="modal-dialog cascading-modal modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header darken-3 justify-content-center text-center text-white contactmodal">
                <h4 class="text-uppercase font-weight-bold text-center mx-5 pt-2">
                    <i class="fa fa-upload px-2"></i>PreRequisite Docket Upload
                </h4>
                <button type="button" class="close waves-effect waves-light " data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">

                <p>Upload Prerequite Docket for the App Type</p>
                <form [formGroup]="group" (submit)="submit($event)" (reset)="reset($event)" f="ngForm">

                    <div id="success1" class="toast-alert alert-success mt-3 " role="alert" data-delay="5000" data-autohide="false" aria-live="assertive" aria-atomic="true" *ngIf="showalertMsg">

                        <div class="toast-body">
                            <i class="fa fa-check" aria-hidden="true"></i>
                            {{alertMsg}}
                        </div>
                    </div>
                    <div id="error" class="toast-alert alert-danger hide mt-3" role="alert" data-delay="5000" data-autohide="true" aria-live="assertive" aria-atomic="true">

                        <div class="toast-body">
                            <i class="fa fa-check" aria-hidden="true"></i>
                            {{alertMsg}}
                        </div>
                    </div>

                    <div class="md-form required">
                        <select class="browser-default custom-select form-control" required autocomplete="off" (selectionChange)="ChangeFileCategory()" formControlName="AppType">
                            <option disabled value="null">Select AppType</option>
                             <option *ngFor="let at of appTypeList" value="{{at.APPTYPE}}">{{at.APPTYPE}}
                            </option>   
                        </select>

                        <span *ngIf="isFileTypeValid" class="customerror">
                            {{FileTypeValidationMsg}}
                        </span>
                    </div>


                    <div>
                        <div class="md-form required">
                            <input #fileInput type="file" (change)="selectFile($event)" style="display:none;" formControlName="fileupload" required id="fileupload" accept='application/zip,application/rar,.zip,.rar,.7zip'>

                            <div class="file-path-wrapper">
                                <i class="fas fa-file-upload iconColor prefix"></i>
                                <input class="form-control required" type="text" placeholder="Upload your file" (click)="fileInput.click()" value="{{fileSelectedCount}}" readonly required autocomplete="off">
                            </div>
                        </div>

                    </div>


                    <!-- <div class="mb-3" *ngIf="showProgress">

                        <mat-card class="full-width-input">
                            <p class="textheader">Uploaded Files</p>
                            <mat-card-subtitle *ngFor="let uploadedFile of uploadedFilesforCategory" class="full-width-input">
                                <div class="uploaded uploadedFiles" *ngIf="showonFileScan">
                                    <mat-icon>insert_drive_file</mat-icon>
                                    <div class="file">
                                        <div class="file__name">
                                         
                                            <p>File Scan InProgress - {{uploadedFile.progress}}%</p>

                                        </div>
                                        <div class="progress">
                                          
                                             <mat-progress-bar mode="determinate" value="{{uploadedFile.progress}}" class="full-width-input">
                                            </mat-progress-bar> 
                                        </div>
                                    </div>
                                </div>
                              
                                <div class="uploaded uploadedFiles" *ngIf="showIfValidFiles">
                                    <mat-icon>check_circle_outline</mat-icon>
                                    <div class="file">
                                        <div class="file__name">
                                            <p>{{uploadedFile.name}} - {{uploadedFile.progress}}%</p>
                                          <mat-icon (click)="removeSelectedFile(index, uploadedFile.name)" style="cursor:pointer">delete</mat-icon> 

                                    </div>
                                </div>
                               

                            </mat-card-subtitle>
                        </mat-card>

                    </div> -->

                    <div class="d-flex justify-content-center adjust" *ngIf="showProgress">



                        <div class="loader " id="loader-4">

                            <span></span>
                            <span></span>
                            <span></span>

                        </div>
                    </div>


                    <div class="text-center">
                        <button mat-raised-button color="primary" class="btn basebtn text-uppercase contactbtn mr-3 waves-effect z-depth-0" type="submit" [disabled]="!group.valid && !this.showSubmitButton">

                            Save
                        </button>




                        <button mat-raised-button class="btn basebtn text-uppercase contactCancelbtn waves-effect z-depth-0" type="reset">

                            Reset
                        </button>


                    </div>

                </form>







            </div>



        </div>

    </div>

</div>